import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from './toast.service';
import { IconComponent } from '../icon/icon';
import type { IconName } from '../icon/icon';
import type { ToastType } from './toast.service';

const TOAST_ICONS: Record<ToastType, IconName> = {
  info: 'info',
  success: 'check-circle',
  warning: 'alert',
  danger: 'alert',
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-toast-container',
  imports: [IconComponent],
  styleUrl: './toast.scss',
  templateUrl: './toast.html',
})
export class ToastContainerComponent {
  private readonly service = inject(ToastService);

  protected readonly toasts = this.service.items;

  protected iconFor(type: ToastType): IconName {
    return TOAST_ICONS[type];
  }

  protected dismiss(id: number): void {
    this.service.dismiss(id);
  }
}
